import React from 'react';
import { useController } from 'react-hook-form';
import { AutoComplete, Body4 } from '@/ui';
import { useCountries } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { Input, Label } from '@/components';
import { getLocalizedText } from '@/utils/helpers';

export const CountryInput = ({ form, label = 'Country', disabled, required, ...props }) => {
  const { t } = useTranslation();
  const { countries } = useCountries();
  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    rules: {
      ...form.rules,
      validate: (v) =>
        !countries ||
        !v ||
        countries.filter((item) => item.country === v)[0] ||
        t('Select country from list')
    },
    defaultValue: ''
  });

  if (disabled) {
    return <Input {...field} label={label} error={error && error.message} {...props} disabled />;
  }

  return (
    <AutoComplete
      style={{ width: '100%' }}
      {...field}
      label={label}
      items={countries && countries.map((item) => item.country)}
      error={error && error.message}
      required={required}
      block
      {...props}
    />
  );
};

export const CountrySelect = ({
  label,
  marginTopLabel,
  tooltip,
  tooltip_RU,
  tooltip_LV,
  required,
  form,
  adminView,
  boldLabel,
  ...props
}) => {
  const { countries } = useCountries();
  const { t, i18n } = useTranslation();

  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    rules: {
      ...form.rules,
      validate: (v) =>
        !countries ||
        !v ||
        countries.filter((item) => item.id === v)[0] ||
        t('Select country from list')
    },
    defaultValue: ''
  });

  return (
    <>
      <Label
        label={label}
        marginTop={marginTopLabel}
        required={required}
        tooltip={
          tooltip
            ? getLocalizedText(
                {
                  tooltip: tooltip,
                  tooltip_RU: tooltip_RU,
                  tooltip_LV: tooltip_LV
                },
                'tooltip',
                i18n
              )
            : null
        }
        bold={boldLabel}
      >
        <Select
          allowClear
          placeholder={label}
          size='large'
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={countries?.map((item) => ({ value: item.id, label: item.country }))}
          {...props}
          {...field}
          error={error && error.message}
        />
      </Label>
      {error && (
        <Body4 $marginTop={8} $color={'#FF424F'}>
          {error.message}
        </Body4>
      )}
    </>
  );
};
